const CustomizedXAxisTick = (props) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={-10}
        y={20}
        textAnchor={payload.value === Number(new Date().getFullYear()) ? "start" : "end"}
        fill="#666"
      >
        {payload.value}
      </text>
    </g>
  );
};

export default CustomizedXAxisTick;
